// The signed-in test-taker's session token. The API also sets it as an httpOnly cookie for
// this site; it's kept here too so embeds (where the cookie is blocked) and apps can send it as
// X-GP-Session. Storage can be missing or blocked (private mode), so every access is guarded.

const KEY = "gp_session";

export function personSession(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function rememberPersonSession(token: string): void {
  try {
    localStorage.setItem(KEY, token);
  } catch {
    // Storage blocked: the cookie still works on this site.
  }
}

export function forgetPersonSession(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Nothing kept.
  }
}
